import { styled } from "@mui/material/styles"
import { useEffect } from "react"
import type { HeaderProps } from "./AppHeader/Header"
import { Header } from "./AppHeader/Header"

const ContentLayout = styled("div")<{
  disableHorizontalGutters?: boolean
  disableLeftGutter?: boolean
}>(({ disableHorizontalGutters, disableLeftGutter, theme }) => ({
  minWidth: 0,
  width: "100%",
  paddingLeft: disableHorizontalGutters ? 0 : 12,
  paddingRight: disableHorizontalGutters ? 0 : 12,
  marginLeft: disableLeftGutter ? 0 : undefined,
  [theme.breakpoints.up("md")]: {
    paddingLeft: disableHorizontalGutters ? 0 : 24,
    paddingRight: disableHorizontalGutters ? 0 : 24,
    marginLeft: disableLeftGutter ? 0 : undefined,
  },
  "@media print": {
    margin: 0,
  },
}))

interface ContentProps extends React.PropsWithChildren {
  headerProps: HeaderProps
  disableHorizontalGutters?: boolean
  disableLeftGutter?: boolean
}
export const MainContent: React.FC<ContentProps> = ({
  headerProps,
  children,
  disableHorizontalGutters,
  disableLeftGutter,
}) => {
  const pageTitle =
    typeof headerProps.title === "string"
      ? headerProps.title
      : headerProps.documentTitle
  useEffect(() => {
    // dynamically update the document title based on the value of title in headerProps
    document.title = `PHC Global${pageTitle ? ` - ${pageTitle}` : ""}`
  }, [pageTitle])

  return (
    <>
      <Header {...headerProps} />
      <ContentLayout
        disableHorizontalGutters={disableHorizontalGutters}
        disableLeftGutter={disableLeftGutter}
      >
        {children}
      </ContentLayout>
    </>
  )
}
